import { querySuppliers } from '../providers/service'
import inv from './inv-config'

export const search = { inputs: inv.search.inputs.slice(0, 11), lines: [] }

search.inputs[0] = {
  type: 'InputSelect',
  title: 'Type',
  span: 6,
  options: 'getters/search/pcPageType',
  getter: 'state/search/orderType',
  setter: 'commit/search/setOrderType',
  defaultValue: 3,
  disabled: true
}

search.inputs[2] = {
  type: 'InputDateRangePicker',
  title: 'ETA Date',
  span: 6,
  getter: 'state/search/deliveryDateRange',
  setter: 'commit/search/setDeliveryDateRange'
}

search.inputs[3] = {
  type: 'InputSelect',
  title: 'TAG',
  span: 6,
  options: 'getters/search/purchaseTagsWithAll',
  getter: 'state/search/tag',
  setter: 'commit/search/setTag',
  disabled: true,
  defaultValue: 0
}

search.inputs[5] = {
  type: 'InputText',
  title: 'Supplier',
  span: 6,
  placeholder: 'Enter Supplier Name',
  getter: 'state/search/csrWord',
  setter: 'commit/search/setCsrWord',
  width: 200
}

search.inputs[7] = {
  type: 'InputSelect',
  title: 'Status',
  span: 6,
  options: 'getters/search/orderStatus',
  getter: 'state/search/status',
  setter: 'commit/search/setStatus',
  defaultValue: 0
}

search.inputs.push({
  type: 'InputSelect',
  title: 'Closure',
  span: 6,
  options: 'getters/search/closures',
  getter: 'state/search/closure',
  setter: 'commit/search/setClosure',
  defaultValue: 0
})

search.lines = [
  ...inv.search.lines.slice(0, 2),
  {
    prop: 'reference',
    label: 'Reference',
    width: 260
  },
  {
    prop: 'customer.name',
    label: 'From Supplier'
  },
  ...inv.search.lines.slice(4, 6),
  {
    prop: 'ColumnShow',
    label: 'Warehouse',
    getter: 'warehouseId',
    trans: 'getters/getWarehouseName',
    width: 120
  },
  {
    prop: 'ColumnShow',
    label: 'Date',
    getter: 'date',
    trans: 'getters/dateFormatAu',
    width: 95
  },
  {
    prop: 'ColumnShow',
    label: 'ETA Date',
    getter: 'deliveryDate',
    trans: 'getters/dateFormatAu',
    align: 'center',
    width: 130
  },
  {
    prop: 'lastApproverAndDate',
    label: 'Last Approver&Date',
    width: 170
  },
  {
    prop: 'status',
    label: 'Status',
    width: 85
  },
  {
    prop: 'closure',
    label: 'Closure',
    width: 90
  },
  {
    ...inv.search.lines[inv.search.lines.length - 1]
  }
]

export const edit = {
  inputs: [
    {
      type: 'InputTagWithOrderType',
      title: 'TAG',
      span: 24,
      placeholder: 'Select',
      options: 'getters/purchaseTags',
      getter: 'state/edit/tagId',
      setter: 'commit/edit/setTag',
      defaultValue: 1,
      disabled: true,
      width: 200
    },
    {
      type: 'divider'
    },
    {
      type: 'InputSelectRemoteSuggestion',
      title: 'Supplier',
      span: 6,
      placeholder: 'Enter Supplier Name',
      query: querySuppliers,
      getter: 'getters/edit/csrName',
      setter: 'commit/edit/setCsr',
      watch: 'state/edit/csr',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Related PO',
      span: 6,
      placeholder: 'For Bills or Bill Creadit Notes',
      getter: 'state/edit/relatedNo',
      setter: 'commit/edit/setRelatedNo',
      disabled: true,
      width: 200
    },
    inv.edit.inputs[4],
    {
      type: 'InputDatePicker',
      title: 'ETA Date',
      span: 6,
      getter: 'state/edit/deliveryDate',
      setter: 'commit/edit/setDeliveryDate',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Reference',
      span: 12,
      placeholder: 'Enter reference only',
      getter: 'state/edit/reference',
      setter: 'commit/edit/setReference',
      width: 615
    },
    inv.edit.inputs[13],
    {
      type: 'InputSelect',
      title: 'Warehouse',
      span: 6,
      placeholder: 'Select Warehouse',
      options: 'state/warehouses',
      getter: 'state/edit/warehouseId',
      setter: 'commit/edit/setWarehouse',
      defaultValue: ''
    },
    {
      type: 'InputSelect',
      title: 'Amt Tax Type',
      span: 6,
      placeholder: 'Select Amount Tax Type',
      options: 'getters/purcahseTaxTypes',
      getter: 'state/edit/taxType',
      setter: 'commit/edit/setTaxType',
      defaultValue: ''
    }
  ],
  lines: [
    {
      prop: 'ColumnProductCodeSelectPopper',
      label: 'Item Code',
      width: 190
    },
    {
      prop: 'ColumnProductNameInput',
      label: 'Item Name',
      width: 330
    },
    {
      prop: 'product.unit',
      label: 'Unit',
      width: 70
    },
    {
      prop: 'ColumnInputQty',
      label: 'Qty',
      width: 85
    },
    {
      prop: 'ColumnPriceDropDownWithInput',
      label: 'Unit Price',
      width: 145
    },
    {
      prop: 'ColumnLineAmount',
      label: 'Line Amount',
      width: 100
    },
    {
      prop: 'ColumnLineTaxType',
      label: 'Tax Type',
      width: 120
    },
    {
      prop: 'ColumnInputDesc',
      label: 'Line Description'
    }
  ]
}

export const draft = {
  inputs: [
    {
      type: 'InputShow',
      title: 'TAG',
      span: 6,
      getter: 'state/edit/tagId',
      trans: 'getters/getTagName',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Number',
      span: 6,
      getter: 'state/edit/no',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'Type',
      span: 6,
      getter: 'state/edit/type',
      trans: 'getters/orderTypeName',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Related Po',
      span: 6,
      getter: 'state/edit/relatedNo',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'divider'
    },
    {
      type: 'InputShow',
      title: 'Supplier',
      span: 12,
      getter: 'getters/edit/csrName',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'Date',
      span: 6,
      getter: 'state/edit/date',
      trans: 'getters/dateFormatAu',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'ETA Date',
      span: 6,
      getter: 'state/edit/deliveryDate',
      trans: 'getters/dateFormatAu',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'Reference',
      span: 12,
      getter: 'state/edit/reference',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Comments',
      span: 12,
      getter: 'state/edit/comments',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Warehouse',
      span: 6,
      getter: 'state/edit/warehouseId',
      trans: 'getters/getWarehouseName',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Amount Tax',
      span: 6,
      getter: 'state/edit/taxType',
      trans: 'getters/getTaxTypeName',
      labelClass: 'detail-text-grey'
    }
  ],
  lines: [
    ...inv.draft.lines.slice(0, 3),
    ...inv.draft.lines.slice(4, 8),

    ...inv.draft.lines.slice(9)
  ]
}
export default { search, edit, draft, approve: draft }
